<div class="explorer-layout">
  <!-- LEFT: Flat MatTree -->
    <div class="left-pane">
      <div class="file-tree-container" [style.width]="leftWidth" [style.height]="height" style="overflow-y:auto">
        <mat-tree [dataSource]="flatData"
                  [levelAccessor]="levelAccessor"
                  [trackBy]="trackByPath"
                  class="file-tree">

          <!-- FILE leaf row -->
          <mat-tree-node *matTreeNodeDef="let node; when: isFlatFile" matTreeNodePadding [attr.data-level]="node.level">
            <div class="node-row">
              <button mat-icon-button disabled class="indent-btn"></button>
              <mat-icon [ngClass]="getFileIconCfg(node).colorClass">
                {{ getFileIconCfg(node).icon }}
              </mat-icon>
              <button mat-button class="btn-bg-blue" (click)="onPreview(node)">{{ node.name }}</button>
              <!--<button mat-icon-button matTooltip="Preview" (click)="onPreview(node)">
                <mat-icon>preview</mat-icon>
              </button>-->
            </div>
          </mat-tree-node>

          <!-- FOLDER expandable row -->
          <mat-tree-node *matTreeNodeDef="let node; when: isFlatFolder"
                         matTreeNodePadding
                         (expandedChange)="onFlatExpanded(node, $event)"
                         [class.folder-node-expanded]="node._expanded"
                         [attr.data-level]="node.level">

            <div class="node-row">
              <button mat-icon-button matTreeNodeToggle (click)="$event.stopPropagation()">
                <mat-icon>{{ node._expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
              </button>
              <mat-icon [ngClass]="getFileIconCfg(node).colorClass" class="node-icon folder">folder</mat-icon>
              <span class="node-name">{{ node.name }}</span>
              <span class="spacer"></span>
              <mat-progress-spinner *ngIf="node._loading"
                                    class="small-spinner"
                                    mode="indeterminate" diameter="18"></mat-progress-spinner>
            </div>
          </mat-tree-node>

        </mat-tree>
      </div>
    </div>

  <!-- RIGHT: Preview -->
  @if (preview) {
    <div class="right-pane" [style.width]="rightWidth" [style.height]="height">
      <div class="preview-toolbar">
        <div class="title">
          <mat-icon>visibility</mat-icon>
          <span>{{ getPreviewTitle() }}</span>
        </div>
        <div class="actions">
          <button mat-icon-button class="btn-bg-green" title="Download File" (click)="onDownload()">
            <mat-icon>download</mat-icon>
          </button>
          <button mat-icon-button class="btn-bg-red" title="Close" (click)="closePreview()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <div class="preview-content">
        <div class="loading" *ngIf="isLoadingPreview()">
          <mat-progress-spinner mode="indeterminate" diameter="28"></mat-progress-spinner>
          <span>Loading preview…</span>
        </div>

        <div class="error" *ngIf="hasErrorPreview()">
          <mat-icon>error</mat-icon>
          <span>{{ preview.error }}</span>
        </div>

        <object *ngIf="isPdfPreview()" [attr.data]="preview.safeUrl" type="application/pdf" class="pdf-object">
          <iframe [src]="preview.safeUrl" class="pdf-iframe"></iframe>
        </object>

        <img *ngIf="isImagePreview()" [src]="preview.url" class="image-preview" alt="Image preview" />

        <pre *ngIf="isTextPreview()" class="text-preview">{{ preview.text }}</pre>

        <iframe *ngIf="isOfficePreview()" [src]="preview.safeUrl" class="office-viewer" referrerpolicy="no-referrer"></iframe>

        <div class="fallback" *ngIf="isFallbackPreview()">
          <mat-icon>insert_drive_file</mat-icon>
          <div>
            <div>No inline preview for this file type.</div>
            <div>Use the <strong>Download</strong> button above.</div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
